import { collab } from '@/utils'
import { CLIENT_CODE_COLLAB } from '@/constants'

import { Params, Response, Service } from '.'

const fetch = async (params: Params): Promise<Response> => {
  try {
    const res = await collab.get<Response>('customer/transaction/history', { params: { ...params, active: 1, code_client: CLIENT_CODE_COLLAB } })
    return res.data
  } catch (e) {
    throw e
  }
}

export const service: Service = {
  fetch
}
